import { ReactElement, useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { history } from 'umi';
import { Col, Row, Statistic } from 'antd';
import { Typography, Button } from 'iglooform';
import './policies-list-item.less';
import { StatusBox } from 'iglooform';
import { images } from '@/assets/images';
import { ArrowRightOutlined } from 'iglooicon';
import Context from '@/utils/context';
import { PolicyStatus, PolicyStatusType } from '@/utils/status';
import moment from 'moment';

const currentLang = localStorage.getItem('selected_lang');

const PoliciesListItem = (props: any): ReactElement => {
  const { policiesListItem, fromPolicy } = props;
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);

  if (!isPc) {
    return (
      <div className="listBox-h5-policy">
        <img
          src={policiesListItem.logo_url || images.tob_icon}
          alt=""
          className="icon"
        />
        <div className="rightDetail">
          <Typography
            level="h4"
            wrapElement="div"
            style={{ marginBottom: '8px' }}
          >
            {policiesListItem.plan_name}
          </Typography>
          <Typography
            level="body2"
            wrapElement="div"
            style={{ marginBottom: '8px' }}
          >
            <Statistic
              value={policiesListItem.premium}
              prefix={formatMessage({ id: 'VND' })}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </Typography>
          <div>
            <StatusBox
              type={PolicyStatusType[policiesListItem?.state]}
              className="state"
            >
              {PolicyStatus[policiesListItem?.state] ? (
                <FormattedMessage {...PolicyStatus[policiesListItem?.state]} />
              ) : (
                policiesListItem?.state
              )}
            </StatusBox>
          </div>
        </div>
        <div className="rightIcon">
          <ArrowRightOutlined
            className="icon"
            onClick={() =>
              history.push(
                fromPolicy
                  ? '/policies/detail?tabKey=policy&id=' +
                      (policiesListItem.id || policiesListItem.id) +
                      '&product_type=' +
                      policiesListItem.product_type +
                      '&product_key=' +
                      policiesListItem.product_key +
                      '&plan_key=' +
                      policiesListItem.plan_key
                  : '/customers/policies/detail?id=' +
                      (policiesListItem.id || policiesListItem.id) +
                      '&product_type=' +
                      policiesListItem.product_type +
                      '&product_key=' +
                      policiesListItem.product_key +
                      '&plan_key=' +
                      policiesListItem.plan_key,
              )
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="listBox">
      <div className="listTopBox">
        <img
          src={policiesListItem.logo_url || images.tob_icon}
          alt=""
          className="icon"
        />
        <Typography level="h4" className="product">
          {policiesListItem.plan_name}
        </Typography>
        <StatusBox
          type={PolicyStatusType[policiesListItem?.state]}
          className="state"
        >
          {PolicyStatus[policiesListItem?.state] ? (
            <FormattedMessage {...PolicyStatus[policiesListItem?.state]} />
          ) : (
            policiesListItem?.state
          )}
        </StatusBox>
        <Button
          onClick={() =>
            history.push(
              fromPolicy
                ? '/policies/detail?tabKey=policy&id=' +
                    (policiesListItem.id || policiesListItem.id) +
                    '&product_type=' +
                    policiesListItem.product_type +
                    '&product_key=' +
                    policiesListItem.product_key +
                    '&plan_key=' +
                    policiesListItem.plan_key
                : '/customers/policies/detail?id=' +
                    (policiesListItem.id || policiesListItem.id) +
                    '&product_type=' +
                    policiesListItem.product_type +
                    '&product_key=' +
                    policiesListItem.product_key +
                    '&plan_key=' +
                    policiesListItem.plan_key,
            )
          }
          className="button"
        >
          {formatMessage({ id: 'View Details' })}
        </Button>
      </div>
      <Row className="listBottomBox">
        <Col span={5}>
          <Typography
            level="body1"
            style={{ display: 'block', marginBottom: '5px', color: '#666666' }}
          >
            {formatMessage({ id: 'Policy Number' })}
          </Typography>
          <Typography level="body1">{policiesListItem.display_id}</Typography>
        </Col>
        <Col span={5}>
          <Typography
            level="body1"
            style={{ display: 'block', marginBottom: '5px', color: '#666666' }}
          >
            {formatMessage({ id: 'Premium' })}
          </Typography>
          <Typography level="body1">
            <Statistic
              value={policiesListItem.premium}
              suffix={formatMessage({ id: 'VND' })}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </Typography>
        </Col>
        <Col span={5}>
          <Typography
            level="body1"
            style={{ display: 'block', marginBottom: '5px', color: '#666666' }}
          >
            {formatMessage({ id: 'Customer Name' })}
          </Typography>
          <Typography level="body1">
            {policiesListItem.customer_name}
          </Typography>
        </Col>
        <Col span={5}>
          <Typography
            level="body1"
            style={{ display: 'block', marginBottom: '5px', color: '#666666' }}
          >
            {formatMessage({ id: 'Policy Start Date' })}
          </Typography>
          <Typography level="body1">
            {moment(policiesListItem.policy_start_at * 1000).format(
              'DD / MM / YYYY',
            )}
          </Typography>
        </Col>
        <Col span={4}>
          <Typography
            level="body1"
            style={{ display: 'block', marginBottom: '5px', color: '#666666' }}
          >
            {formatMessage({ id: 'Policy End Date' })}
          </Typography>
          <Typography level="body1">
            {moment(policiesListItem.policy_expire_at * 1000).format(
              'DD / MM / YYYY',
            )}
          </Typography>
        </Col>
      </Row>
    </div>
  );
};

export default PoliciesListItem;
